import {
  Widget,
  getWidgetProps,
  WPSClient,
  RequestContext,
  DVString,
} from 'DVWebNodeUtils'
import { Banner } from './components/Banner'
import { isRetail } from './utils/utils'

export interface PangaeaBannerProps  {
  banner?: DVString
  csrfToken: string
  context: RequestContext
}

const getProps: getWidgetProps<PangaeaBannerProps> = global.__SERVER__
  ? async ({ context }, api) => {
    const wpsClient = new WPSClient(api)
    // We show banners to recognized Retail customers only
    if (Boolean(context.customerID) && isRetail(context.domain)) {
      const response = await wpsClient.GetPangaeaBanner({ context: context })
      return {
        ...response,
        context
      }
    } else {
      return undefined
    }
  } : undefined

export const PangaeaBanner: Widget<PangaeaBannerProps> = {
  name: 'pangaea-banner',
  getProps,
  Component: Banner,
}
